'use strict';

function accordionFunction(g) {
  var $accordions = $('.accordion__button');

  function init() {
    $accordions.click(function(e) {
      clickAccordion($(e.currentTarget));
    });

    $(window).resize(resizeAccordion);

    openAccordionIfAnchor();
  }

  function clickAccordion(target) {
    target.parent().toggleClass('is-open');
    var content = target.next('.accordion__content')[0];
    if (content.style.maxHeight) {
      // accordion is currently open, so close it
      content.style.maxHeight = null;
    } else {
      // accordion is currently closed, so open it
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  function resizeAccordion() {
    if ($('.accordion').hasClass('is-open')) {
      var $accordionContent = $('.is-open .accordion__content');
      $accordionContent.each(function(index) {
        $accordionContent[index].style.maxHeight = $accordionContent[index].scrollHeight + 'px';
      });
    }
  }

  // S'il y a une ancre ("#" dans l'URL), on ouvre l'accordéon correspondant
  function openAccordionIfAnchor() {
    var hash = window.location.hash;

    if (hash) {
      if ($(hash).length === 0) {
        return;
      }

      clickAccordion($(hash).closest('.accordion__button'));
    }
  }

  init();
}
